<script lang="ts" setup>
import { router } from "@inertiajs/vue3";

const props = defineProps<{
  href?: string;
  hoverLightUp?: boolean;
  onClick?: () => void;
}>();

function visit(): void {
  if (props.href !== undefined) {
    router.visit(props.href);
  }
}

const emit = defineEmits<{
  hovering: [hovering: boolean];
}>();

function hovering(hovering: boolean): void {
  if (props.href !== undefined || props.hoverLightUp) {
    emit("hovering", hovering);
  }
}
</script>

<template>
  <footer
    :class="{ 'hover:cursor-pointer': href }"
    class="inline-flex items-center justify-end gap-2 border-t border-green-900/75 bg-black/25 p-4 text-right text-sm font-medium tracking-wider"
    @click="onClick !== undefined ? onClick() : visit()"
    @mouseenter="hovering(true)"
    @mouseleave="hovering(false)"
  >
    <slot />

    <i-fa6-solid-arrow-right v-if="href" class="inline" />
  </footer>
</template>

<style scoped></style>
